var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"assessmentIframe","src":_vm.$config.get('basePathFiles') + 'static/libs/assessments/index.html'},on:{"load":function($event){return _vm.loadAssessmentDetails()}}})}
var staticRenderFns = []

export { render, staticRenderFns }